import { BasePredictionRecordsByModelVersionT } from '@shared/types';
import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { toSeasonWeekID } from 'helpers/IdHelpers';
import { IGameContextEnrichment, IMatchup } from 'types';

// #region CONVERTERS *******************************************************************
export const matchupToDoc = (game: IMatchup): DocumentData => {
  return {
    gameID: game.gameID,
    home: game.home,
    away: game.away,
    teamIDHome: game.teamIDHome,
    teamIDAway: game.teamIDAway,
    gameWeek: game.gameWeek,
    gameDate: game.gameDate,
    gameTime: game.gameTime,
    season: game.season,
    seasonType: game.seasonType,
    neutralSite: game.neutralSite,
    gameTime_epoch: game.gameTime_epoch,
    gameStatus: game.gameStatus,
    gameStatusCode: game.gameStatusCode,
    seasonWeekID: game.seasonWeekID ?? toSeasonWeekID(game.season, game.gameWeek),
    awayPts: game.awayPts || '',
    awayResult: game.awayResult || '',
    homePts: game.homePts || '',
    homeResult: game.homeResult || '',
    lineScore: game.lineScore,
    gameContext: game.gameContext as IGameContextEnrichment | undefined,
    predictions: (game.predictions as BasePredictionRecordsByModelVersionT) || {},
  };
};

export const matchupConverter: FirestoreDataConverter<IMatchup> = {
  toFirestore(game: IMatchup): DocumentData {
    return matchupToDoc(game);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): IMatchup {
    const game = docSnap.data(options);

    return {
      gameID: game.gameID,
      home: game.home,
      away: game.away,
      teamIDHome: game.teamIDHome,
      teamIDAway: game.teamIDAway,
      gameWeek: game.gameWeek,
      gameDate: game.gameDate,
      gameTime: game.gameTime,
      season: game.season,
      seasonType: game.seasonType,
      neutralSite: game.neutralSite,
      gameTime_epoch: game.gameTime_epoch,
      gameStatus: game.gameStatus,
      gameStatusCode: game.gameStatusCode,
      seasonWeekID: game.seasonWeekID ?? toSeasonWeekID(game.season, game.gameWeek),
      awayPts: game.awayPts || '',
      awayResult: game.awayResult || '',
      homePts: game.homePts || '',
      homeResult: game.homeResult || '',
      lineScore: game.lineScore,
      gameContext: game.gameContext as IGameContextEnrichment | undefined,
      predictions: (game.predictions as BasePredictionRecordsByModelVersionT) || {},
    };
  },
};
// #endregion
